<div class="dialog-content-wrapper">
    <div class="m-0 flex w-full items-center justify-between bg-[#039be5] text-white p-4 ">
        <span class="text-4xl">{{dialogTitle}}</span>
        <mat-icon class="hover:bg-blue-400 hover:rounded  text-white" (click)="matDialogRef.close()">close</mat-icon>
    </div>

    <div mat-dialog-content class="m-0">
        <form [formGroup]="reportForm" class="space-y-4">
            <div class="flex flex-row items-start justify-start">
                <mat-form-field dense appearance="outline" class="w-full" floatLabel="always">
                    <mat-label>Template</mat-label>
                    <mat-select formControlName="template">
                        <mat-option *ngFor="let rep of reports" [value]="rep" (onSelectionChange)="templateChanged(rep,$event)">
                            {{noExtensionName(rep.name)}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="noDates" class="flex flex-row items-center p-2">
                <mat-checkbox dense (change)="setDisabled($event.checked)" formControlName="noDates">Sin fechas</mat-checkbox>
            </div>

            <div *ngIf="selected" class="flex flex-row items-center p-2">
                <mat-checkbox dense formControlName="selected">Seleccionados</mat-checkbox>
            </div>

            <div *ngIf="fromTo" class="flex flex-row gap-4 items-start">
                <mat-form-field dense appearance="outline" class="flex-1">
                    <mat-label>Desde</mat-label>
                    <input type="date" name="from" formControlName="from" matInput>
                </mat-form-field>
                <mat-form-field dense appearance="outline" class="flex-1">
                    <mat-label>Hasta</mat-label>
                    <input type="date" name="to" formControlName="to" matInput>
                </mat-form-field>
            </div>

            <!-- Cliente -->
            <div *ngIf="client" class="flex flex-row items-start">
                <mat-form-field dense appearance="outline" floatLabel="always" class="w-full">
                    <mat-label>Cliente</mat-label>
                    <mat-select [compareWith]="_systemService.compareFunction" formControlName="client">
                        <mat-option *ngFor="let client of clients" [value]="client">
                            {{client.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Estado -->
            <div *ngIf="status" class="flex flex-row items-start">
                <mat-form-field dense appearance="outline" floatLabel="always" class="w-full">
                    <mat-label>Estado</mat-label>
                    <mat-select formControlName="status">
                        <mat-option *ngFor="let status of projectStatuses" [value]="status">
                            {{status}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Responsable -->
            <div *ngIf="inCharge" class="flex flex-row items-start">
                <mat-form-field dense appearance="outline" floatLabel="always" class="w-full">
                    <mat-label>Responsable</mat-label>
                    <mat-select [compareWith]="_systemService.compareFunction" formControlName="inCharge">
                        <mat-option *ngFor="let user of users" [value]="user">
                            {{user.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="m-0 px-4 py-2 flex items-center justify-end gap-2">
        <button mat-button class="mr-2" (click)="matDialogRef.close()" aria-label="Delete" matTooltip="Cancelar">
            Cancelar
        </button>

        <button mat-button class="save-button" (click)="matDialogRef.close(reportForm)" [disabled]="reportForm.invalid" aria-label="SAVE">
            Generar Reporte
        </button>
    </div>
</div>
